import { skillsRatingRef } from "./vue-service-database.js";
import store from "@/store/";

function updateSelectedPersonSkillsRating(skillsRating) {
	let personKey = store.getters.selectedPersonKey;
	let personRef = skillsRatingRef.child("byPerson").child(personKey);
	//personRef.child("skills").set(skillsRating);
	personRef.child("skills").set(JSON.parse( JSON.stringify(skillsRating)));
	personRef.child("skills").once("value").then(snapshot => {
		let updatedSkillsRating = snapshot.val();
		store.dispatch("SET_SELECTED_PERSON_SKILLS_RATING", updatedSkillsRating);
	});
}
function updatePersonSkillsRating(personKey, skillsRating) {
	let personRef = skillsRatingRef.child("byPerson").child(personKey);
	//personRef.child("skills").set(skillsRating);
	personRef.child("skills").set(JSON.parse( JSON.stringify(skillsRating)));
	personRef.child("skills").once("value").then(snapshot => {
		let updatedSkillsRating = snapshot.val();
		store.dispatch("SET_SELECTED_PERSON_SKILLS_RATING", updatedSkillsRating);
	});
}
function setSelectedPersonSkillsRating(personKey) {
	let person = store.getters.skillsRatingByPerson[personKey];
	let skillsRating = {};
	if (person) {
		skillsRating = person.skills;
	}
	store.dispatch("SET_SELECTED_PERSON_SKILLS_RATING", skillsRating);
}

export {
	updateSelectedPersonSkillsRating,
	setSelectedPersonSkillsRating,
	updatePersonSkillsRating
};


// WEBPACK FOOTER //
// ./src/vue-service-skills.js